import React, { useState } from "react";
import { CLICK, component, demoFile, feature, story } from "system/demo";
import { CatToggle, CatState, TypeFilter } from "feature/comments/demo-filter";
import type { CatComment } from "feature/comments/demo-filter";

demoFile('feature/comments/demo-filter');

feature('Demo Filter', {
    structureKey: 'simplecomments',
    features: {demofilter: true}
});

function CatToggleDemo() {
    const [comment, setComment] = useState<CatComment>({
        key: 'c1',
        text: '',
        from: 'u1',
        time: Date.now(),
        isCat: false,
    });
    return <CatToggle comment={comment} setComment={setComment as (c: CatComment) => void} />;
}

component('CatToggle', CatToggleDemo, {}, [
    story('Toggle', [CLICK('!Is Cat')])
]);

component('CatState', CatState, {
    args: {
        comment: {key: 'c2', text: '', from: 'u1', time: Date.now(), isCat: true} as CatComment
    }
});
component('TypeFilter', TypeFilter, {}, [
    story('Enable', [CLICK('!Only Cats')])
]);

